import StorageHelper from '../../../helper';

const scope = 'CAMP/content';

const mod = {
  namespaced: true,
  state: {
    collapseLabel: "",
    defaultCollapseMobileDescription: true,
    expandLabel: "",
  },
  mutations: {
    collapseLabel: (state, collapseLabel) => {
      state.collapseLabel = collapseLabel;
    },
    defaultCollapseMobileDescription: (state, defaultCollapseMobileDescription) => {
      state.defaultCollapseMobileDescription = defaultCollapseMobileDescription;
    },
    expandLabel: (state, expandLabel) => {
      state.expandLabel = expandLabel;
    },
  },
  actions: {
    collapseLabel({ commit }, label) {
      StorageHelper.setLocalStorageVar(commit, label, 'collapseLabel', scope);
    },
    defaultCollapseMobileDescription({ commit }, description) {
      StorageHelper.setLocalStorageVar(commit, description, 'defaultCollapseMobileDescription', scope);
    },
    expandLabel({ commit }, label) {
      StorageHelper.setLocalStorageVar(commit, label, 'expandLabel', scope);
    },
  },
  getters: {
    collapseLabel: state => state.collapseLabel,
    defaultCollapseMobileDescription: state => state.defaultCollapseMobileDescription,
    expandLabel: state => state.expandLabel,
  },
};

export {
  mod as default
};
